import React from "react";
import { Icon } from "@iconify/react";

const iconCheck: React.FC = () => (
  <Icon icon="ic:round-check" color="#28a745" fontSize={30} />
);
export default iconCheck;
